import { render, staticRenderFns } from "./AntecedentsJudiciaires.vue?vue&type=template&id=23ff93f4"
import script from "./AntecedentsJudiciaires.vue?vue&type=script&lang=js"
export * from "./AntecedentsJudiciaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports